<template>
  <div class="about-us-page-banner-container">
    <img src="@/assets/images/about-us-page-banner.png" alt="" />
    <div class="banner-title-container">
      <div class="main-title wow fadeInLeft">
        <img src="@/assets/images/about-us-banner-title.png" alt="" />
      </div>
      <div class="consult-btn wave wow fadeInLeft" @click="openContactCard">
        <span>咨询获取支持</span>
      </div>
    </div>
    <contact-card ref="contactCard"></contact-card>
  </div>
</template>

<script>
import contactCard from "@/view/components/contactCardDialog";
export default {
  components: {
    contactCard,
  },
  data() {
    return {};
  },
  methods: {
    openContactCard() {
      this.$refs.contactCard.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.about-us-page-banner-container {
  position: relative;
  padding-top: 70px;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 230px;
  background: #0764FB;
  img {
    width: 100%;
  }
  .banner-title-container {
    position: absolute;
    // top: 30%;
    left: 10%;
    // height: 30%;
    .main-title {
      img {
        width: 50%;
      }
    }
    .consult-btn {
      margin-top: 3%;
      width: 136px;
      height: 40px;
      border: 1px solid #ffffff;
      border-radius: 20px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      @include btn;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/components/banner.vue